import Vue from "vue";
import Router from "vue-router";
import Nosotros from "./views/Nosotros.vue";
import Servicios from "./views/Servicios.vue";
import AutogestionPaciente from "./components/AutogestionPaciente/AutogestionPaciente.vue";
import PoliticaPrivacidad from "./components/PoliticaPrivacidad/PoliticaPrivacidad.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: AutogestionPaciente
    },
    {
      path: "/nosotros",
      name: "nosotros",
      component: Nosotros
    },
    {
      path: "/servicios",
      name: "servicios",
      component: Servicios
    },
    {
      path: "/politicaprivacidad",
      name: "politicaprivacidad",
      component: PoliticaPrivacidad
    }
  ]
});
